import { Button, Checkbox, Input } from '@deere/fuel-react';
import { useState } from 'react';

export const ImpersonateInput = ({
    callback,
    impersonatedId,
    impersonatedIsAdmin,
}) => {
    const [impId, setImpId] = useState(impersonatedId);
    const [impIsAdmin, setImpIsAdmin] = useState(impersonatedIsAdmin);
    return (
        <>
            <Input
                placeholder="Impersonated RACF"
                onChange={(e) => setImpId(e.target.value)}
            />
            <Checkbox onChange={(e, checked) => setImpIsAdmin(checked)}>
                Admin
            </Checkbox>
            <Button onClick={() => callback(impId, impIsAdmin)}>Go</Button>
        </>
    );
};
